import { useState } from 'react'

import { useMutation } from '@apollo/client'
import { useNotifications } from '@joor/design-system'

import { SyncShopifyOrderStylesDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation SyncShopifyOrderStyles(
    $syncShopifyOrderStylesInput: SyncShopifyOrderStylesInput!
  ) {
    syncShopifyOrderStyles(input: $syncShopifyOrderStylesInput) {
      jobIds
    }
  }
`

export const useSyncShopifyOrderStyles = () => {
  const { addToasts } = useNotifications()
  const [syncStarted, setSyncStarted] = useState(false)

  const [mutate, { loading }] = useMutation(SyncShopifyOrderStylesDocument, {
    client: atlasClient,
    onCompleted: () => {
      addToasts([
        {
          type: 'warning',
          title: 'Syncing Styles',
          description:
            'Styles are being synced into Shopify. This might take some time.',
        },
      ])
    },
    onError: () => {
      setSyncStarted(false)
      addToasts([
        {
          type: 'error',
          title: 'Error',
          description: 'Failed to sync, please try again',
        },
      ])
    },
  })
  return {
    syncShopifyOrderStyles: (orderIds: string[]) => {
      setSyncStarted(true)
      mutate({ variables: { syncShopifyOrderStylesInput: { orderIds } } })
    },
    loading,
    syncStarted,
  }
}
